import { gql, useLazyQuery } from "@apollo/client";

export const GET_MEMBER_BOOKINGS = gql`
  query getMemberBookings($memberId: ID!, $accountId: ID!) {
    account {
      id
      member(id: $memberId) {
        bookingsCount(sourceAccountId: $accountId) {
          upcomingAccepted
        }
      }
    }
  }
`;

export const useMemberBookings = memberId => {
  const [getMemberBookings, { loading, error }] = useLazyQuery(
    GET_MEMBER_BOOKINGS
  );

  const checkClientBookings = async accountId => {
    return getMemberBookings({
      variables: {
        memberId,
        accountId
      }
    });
  };

  return {
    checkClientBookings,
    loading,
    error
  };
};
